export default __webpack_public_path__ + "static/architecture-a81639552842e4786615e2c495ee5047.jpg";